import React from 'react';
import ContactsContainer from '../containers/ContactsContainer'
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'

const ContactsPage = ({ match, location }) => {
    const { 
        state: { serviceId, isClaroPartner, isContainerTelcel }
    } = location;
  
    sdkclaro.getInstance().switchGoBackButton(true)

    return (
        <Page id="contacts-page">
            <ContactsContainer serviceId={serviceId} isClaroPartner={isClaroPartner} isContainerTelcel={isContainerTelcel} />
        </Page>    
  );
};


export default ContactsPage